import Head from 'next/head'

import ChangelogPageContent from '@/components/changelog/ChangelogPage'
import ClientErrorBoundary from '@/components/error/ClientErrorBoundary'
import { getLayout } from '@/components/layouts/changelog/Layout'
import { getMetadataFn } from '@/components/seo/DefaultMetadata'

import { requireAuth } from '@/helpers/auth'

import type { NextPageWithLayout } from '@/types/next'

const ChangelogPage: NextPageWithLayout = () => {
  return (
    <>
      <Head>
        <title>Changelog - Sweetspot Console</title>
      </Head>
      <ClientErrorBoundary>
        <ChangelogPageContent />
      </ClientErrorBoundary>
    </>
  )
}

ChangelogPage.getLayout = getLayout
ChangelogPage.getMetadata = getMetadataFn()

export default requireAuth(ChangelogPage)
